import { render, staticRenderFns } from "./SourcesTrendChart.vue?vue&type=template&id=2d684fe0&scoped=true&"
import script from "./SourcesTrendChart.vue?vue&type=script&lang=js&"
export * from "./SourcesTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./SourcesTrendChart.vue?vue&type=style&index=0&id=2d684fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d684fe0",
  null
  
)

export default component.exports